import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UseCaseRequestForm from '../../components/usecases/UseCaseRequestForm';

const RequestUseCase: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const initialPromoterId = (location.state as { promoterId?: string } | null)?.promoterId;

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm">
          <div className="border-b border-gray-200 p-6 bg-gradient-to-r from-violet-500 to-purple-500 text-white rounded-t-xl">
            <h1 className="text-2xl font-bold">{t('useCases.requestPage.title')}</h1>
            <p className="text-violet-100 mt-1">{t('useCases.requestPage.subtitle')}</p>
          </div>

          <div className="p-8">
            <UseCaseRequestForm initialPromoterId={initialPromoterId} onClose={() => navigate('/use-cases')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestUseCase;
